<div class="mb-4" id="searchTable" *ngIf="pagedData.length > 0">
<div class="d-flex align-items-center justify-content-between flex-wrap mb-3" id="table-header">
    <h5 class="mb-0">{{ title }}</h5>
    <div class="d-flex align-items-center gap-2 mb-1">
      <button class="btn d-flex align-items-center mb-1" (click)="exportCSV(data, title + '.csv')" id="download">
        <span *ngIf="!downloadedTable" class="material-symbols-outlined me-1" style="font-size: 1.2rem">download</span>
        <span *ngIf="downloadedTable" class="material-symbols-outlined me-1"
              style="font-size: 1.2rem"> download_done</span>
        Export {{ title }}
      </button>
    </div>
  </div>
  <div class="table-responsive card rounded-3 shadow-sm">
    <table class="table table-borderless">
      <thead>
      <tr>
        <th *ngFor="let col of columns">{{ col.header }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of pagedData">
        <td *ngFor="let col of columns">{{ displayValue(row, col.field) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<div
  class="d-flex justify-content-between align-items-center mt-2"
  *ngIf="totalPages > 1"
>
  <button class="btn btn-sm paginationBtn"
          (click)="prevPage()"
          [disabled]="currentPage === 1">
    Previous
  </button>

  <span style="color: var(--darkerblue)">
    Page {{ currentPage }} of {{ totalPages }}
  </span>

  <button class="btn btn-sm paginationBtn"
          (click)="nextPage()"
          [disabled]="currentPage === totalPages">
    Next
  </button>
</div>

